import { render, staticRenderFns } from "./SymmRAQ.vue?vue&type=template&id=7b470722&scoped=true"
import script from "./SymmRAQ.vue?vue&type=script&lang=js"
export * from "./SymmRAQ.vue?vue&type=script&lang=js"
import style0 from "./SymmRAQ.vue?vue&type=style&index=0&id=7b470722&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b470722",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
